// src/context/TableContext.js
import React, { createContext, useState } from "react";

// Context oluştur
export const TableContext = createContext();

// Provider
export const TableProvider = ({ children }) => {
  // Örnek kullanıcı verileri
   const [users, setUsers] = useState([
    { id: 1, name: "Gamze", surname: "Batur", email: "gamze@example.com", status: "Aktif" },
    { id: 2, name: "Ahmet", surname: "Yılmaz", email: "ahmet@example.com", status: "Pasif" },
    { id: 3, name: "Elif", surname: "Demir", email: "elif@example.com", status: "Aktif" },
    { id: 4, name: "Caner", surname: "Kaya", email: "caner@example.com", status: "Pasif" },
    { id: 5, name: "Selin", surname: "Arslan", email: "selin@example.com", status: "Aktif" },
    { id: 6, name: "Mert", surname: "Tunç", email: "mert@example.com", status: "Pasif" },
    { id: 7, name: "Deniz", surname: "Koç", email: "deniz@example.com", status: "Aktif" },
    { id: 8, name: "Ayşe", surname: "Çelik", email: "ayse@example.com", status: "Pasif" },
    { id: 9, name: "Emre", surname: "Yıldız", email: "emre@example.com", status: "Aktif" },
    { id: 10, name: "Zeynep", surname: "Öztürk", email: "zeynep@example.com", status: "Pasif" },
 { id: 5, name: "Selin", surname: "Arslan", email: "selin@example.com", status: "Aktif" },
    { id: 6, name: "Mert", surname: "Tunç", email: "mert@example.com", status: "Pasif" },
    { id: 7, name: "Deniz", surname: "Koç", email: "deniz@example.com", status: "Aktif" },
    { id: 8, name: "Ayşe", surname: "Çelik", email: "ayse@example.com", status: "Pasif" },
    { id: 9, name: "Emre", surname: "Yıldız", email: "emre@example.com", status: "Aktif" },
    { id: 10, name: "Zeynep", surname: "Öztürk", email: "zeynep@example.com", status: "Pasif" },

  ]);

  // Yeni kullanıcı ekleme
  const addUser = (user) => setUsers((prev) => [...prev, user]);

  // Kullanıcı güncelleme
  const updateUser = (id, updatedUser) => {
    setUsers((prev) => prev.map((u) => (u.id === id ? updatedUser : u)));
  };

  // Kullanıcı silme
  const deleteUser = (id) => setUsers((prev) => prev.filter((u) => u.id !== id));

  return (
    <TableContext.Provider value={{ users, addUser, updateUser, deleteUser }}>
      {children}
    </TableContext.Provider>
  );
};
